<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ userName }}</p>
                <button class="delete" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <div class="camera-container">
                    <video autoplay ref="video"></video>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" @click="close">
                    {{ $t("big-participant.close") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "big-participant",
    props: {
        userName: {
            type: String,
            default: "",
        },
        stream: {
            type: MediaStream,
            required: true,
        },
    },
    mounted() {
        this.loadParticipant();
    },
    methods: {
        loadParticipant() {
            this.$refs.video.srcObject = this.stream;
        },
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.camera-container {
    display: inline-block;
    width: 100%;
    text-align: center;
}
</style>